import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/axelerate-logo-purple.svg'


const _hoisted_1 = { class: "bg-background min-h-screen" }
const _hoisted_2 = { class: "flex flex-col justify-center items-center min-h-screen" }
const _hoisted_3 = { class: "flex flex-col bg-white shadow rounded-2xl w-1/2 xl:w-1/3 p-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-1/2"
}, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_6 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "Complete your account", -1)
const _hoisted_8 = { class: "flex flex-col mt-8" }
const _hoisted_9 = { class: "relative flex flex-row items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.error)
          ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.step === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("form", {
                        onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "mb-6",
                            key: `item-input-${index + 1}`
                          }, [
                            _createVNode(_component_TextField, {
                              name: item.name,
                              label: item.label,
                              disabled: index !== 3 ? item.disabled : _ctx.isOwner,
                              error: _ctx.errors[item.name],
                              typeInput: item.type
                            }, null, 8, ["name", "label", "disabled", "error", "typeInput"])
                          ]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwords, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "mb-6",
                            key: `item-input-${index + 1}`
                          }, [
                            _createVNode(_component_TextField, {
                              name: item.name,
                              label: item.label,
                              disabled: index !== 3 ? item.disabled : _ctx.isOwner,
                              error: _ctx.errors[item.name],
                              typeInput: item.type
                            }, null, 8, ["name", "label", "disabled", "error", "typeInput"])
                          ]))
                        }), 128)),
                        _createElementVNode("button", {
                          type: "submit",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                          class: _normalizeClass(["w-full mt-4", _ctx.loading ? 'btn-filled-lg-loading' : 'btn-filled-lg'])
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            (_ctx.loading)
                              ? (_openBlock(), _createBlock(_component_Spinner, {
                                  key: 0,
                                  color: "white",
                                  height: "6",
                                  width: "6",
                                  border: "2"
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", {
                              class: _normalizeClass(_ctx.loading ? 'ml-4' : '')
                            }, " Complete Account ", 2)
                          ])
                        ], 2)
                      ], 32)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ])
  ]))
}